import React from "react";
import { Reveal, Overline } from "./Motion";
import { EVENTS } from "@/data/cafe";
import { useDialogs } from "./DialogProvider";
import { Mic, Music, Cake, Briefcase, GraduationCap, ArrowRight } from "lucide-react";

const ICONS = [Mic, Music, Cake, Briefcase, GraduationCap];

export default function Events() {
  const { open } = useDialogs();
  return (
    <section id="events" className="bg-[#1A1514] py-24 md:py-32" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Overline>Events</Overline>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F2EB] mt-4 font-medium">
              More than <span className="italic text-[#1C7C54]">coffee</span>
            </h2>
          </div>
          <button onClick={() => open("event")} data-testid="events-book-btn"
            className="self-start rounded-sm bg-[#1C7C54] text-[#F5F2EB] px-7 py-3.5 font-accent text-xs uppercase tracking-[0.15em] hover:bg-[#14603F] transition-colors">
            Book an Event
          </button>
        </div>

        <div className="mt-14 border-t border-white/10">
          {EVENTS.map((ev, i) => {
            const Icon = ICONS[i] || Mic;
            return (
              <Reveal key={ev.type} delay={(i % 3) * 0.05}>
                <button onClick={() => open("event", { eventType: ev.type })} data-testid={`event-row-${i}`}
                  className="w-full text-left grid grid-cols-12 gap-4 items-center py-7 border-b border-white/10 group hover:bg-white/[0.03] transition-colors px-2">
                  <div className="col-span-2 md:col-span-1"><Icon className="h-6 w-6 text-[#1C7C54]" strokeWidth={1.5} /></div>
                  <h3 className="col-span-10 md:col-span-3 font-display text-2xl md:text-3xl text-[#F5F2EB] group-hover:translate-x-1 transition-transform duration-300">{ev.title}</h3>
                  <p className="col-span-10 col-start-3 md:col-span-7 md:col-start-5 font-body text-[#F5F2EB]/55">{ev.desc}</p>
                  <ArrowRight className="hidden md:block md:col-span-1 h-5 w-5 text-[#F5F2EB]/40 group-hover:text-[#1C7C54] group-hover:translate-x-1 transition-all duration-300 justify-self-end" />
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
